import { createQueryUrl } from 'components/SearchSideBar/logics/createSearchResultPageUrl';
import { SelectedCurrentConditionType } from 'types/searchCondition';
import { createConditionQueryObject } from './createConditionQueryObject';
import { DEFAULT_PARAMS } from '../../../../constants';
import { createUrl } from '../../logics/createUrl';

/**
 * moveToSearchResultPage 引数を表すインターフェース
 */
interface ArgumentType {
  /** 現在選択されている検索条件 */
  selectedSearchCondition: SelectedCurrentConditionType;
  /** fidのクエリストリング */
  fidQuery: string | undefined;
}

/**
 * 遷移先URLの生成処理を実行し、検索結果ページへ遷移
 *
 * @param {ArgumentType} params - 引数のオブジェクト
 * @param {SelectedCurrentConditionType} params.selectedSearchCondition - 現在選択されている検索条件
 * @param {string | undefined} params.fidQuery - fidのクエリストリング
 * @returns {void} URLを生成して検索結果ページに遷移
 */
export const moveToSearchResultPage = ({
  selectedSearchCondition,
  fidQuery,
}: ArgumentType) => {
  // 検索条件のクエリ文字列を生成
  const searchConditionQuery = createQueryUrl(
    createConditionQueryObject({
      selectedCurrentCondition: selectedSearchCondition,
      defaultParams: DEFAULT_PARAMS,
      fidQuery,
    })
  );

  const url = createUrl(searchConditionQuery);

  window.location.href = url;
};
